function mergePagePilotVariants() {
  const allLabels = document.querySelectorAll('label[for^="template--"]');
  if (!allLabels.length) return;

  const container = allLabels[0].closest('.pp-grid, .pp-flex, fieldset, div');
  if (!container || container.dataset.merged) return;

  container.dataset.merged = "true";

  const select = document.createElement('select');
  select.className = 'pp-variant-dropdown';

  allLabels.forEach((label, index) => {
    const option = document.createElement('option');
    option.value = index;
    option.textContent = label.textContent.trim();
    select.appendChild(option);

    label.addEventListener('click', () => {
      select.selectedIndex = index;
    });
  });

  select.addEventListener('change', () => {
    allLabels[select.selectedIndex]?.click();
  });

  container.appendChild(select);
}

setInterval(mergePagePilotVariants, 500);
